module.exports = __webpack_public_path__ + "static/Abacus Mitarbeiterportal LEHMANNPARTNER-06b1527b10de09cf88f65828df029519.pdf";